import React, { Component } from 'react';
import { Drawer } from '@material-ui/core';

import SignUp from '../SignUp';


export default class SignUpDrawer extends Component {
	render() {
		return (
			<Drawer className="mbl-drawer" open={this.props.openSignUpDrawer} onClose={this.props.toggleSignUpDrawer} anchor="right">
				<div style={{ width: 423, padding: '15px 25px', boxSizing: 'border-box' }}>
					<SignUp toggleSignUpDrawer={this.props.toggleSignUpDrawer} closeLoginDrawer={this.props.toggleSignUpDrawer} />
				</div>
			</Drawer>
		);
	}
}
